<div leaflet class="leaflet-container" [leafletOptions]="options" (leafletMapReady)="onMapReady($event)">
</div>
